import { Box, Button, Menu, MenuItem, ButtonGroup, Card, Checkbox, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Search as SearchIcon, Download as ExportIcon,  } from 'react-feather';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import CustomButton from 'src/components/common/customButton';

const GoldResults = ({ totalCount, onPaginationChange, exportFile, displayEmployees, allEmployees, activeBookings, activeTable, ...props }) => {
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [exportType, setExportType] = useState('xlsx');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [employees, setEmployees] = useState((displayEmployees.length > 0) && displayEmployees.slice(page * limit, (page + 1) * limit));
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    if (activeTable == 1) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
  };

  const fileList = [ {
    id: 'XLSX',
    title: 'xlsx'
  },{
    id: 'CSV',
    title: 'csv'
  }]

  const handleClose = (item) => {
    setAnchorEl(null);
    if(item){
      setExportType(item.title)
    }
  };

  const setActiveTable = (value) =>{
    setLimit(5)
    setPage(0)
    props.setActiveTable(value)
  }

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (activeTable == 1) {
      onPaginationChange('page', newPage, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('page', newPage, activeTable);
    }
  };
  return (
    <>
      <Grid container>
        <Grid xs={12} justifyContent="space-between" container item>
          <Grid item container
            sx={{
              borderRadius: 3,
              border: '1px solid #1778f2',
              width: '302px',
              height: '40px'
            }}>
            <CustomButton loading={props.loading.activeBookings || props.loading.allEmployees}
              onClick={() => setActiveTable(0)} fontSize={12} shadow="false" active={activeTable == 0} title="Gold"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }} />
            <CustomButton loading={props.loading.activeBookings || props.loading.allEmployees}
              onClick={() => setActiveTable(1)} fontSize={12} shadow="false" active={activeTable == 1} title="All Consultations"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }} />
          </Grid>
          <Grid item container sx={{
            width: '180px'
          }}>
            <ButtonGroup variant="text" disabled={false} sx={{boxShadow: '0 0 4px rgba(0,0,0,0.20)', borderRadius: 15}}>
                  <Button sx={{ px: 2 }} onClick={() => exportFile(exportType)} 
                  startIcon={<ExportIcon size="18"/>}>
                    Export
                  </Button>
                  <Button onClick={(e)=> setAnchorEl(e.currentTarget)} endIcon={<ArrowDropDownIcon/>}>
                    {exportType}
                  </Button>
              </ButtonGroup>
          </Grid>
          <Menu
            id="export-menu"
            open={open}
            anchorEl={anchorEl}
            onClose={()=>handleClose()}
            MenuListProps={{
              'aria-labelledby': 'exporttypeMenu',
            }}
          >
            { fileList.map((menu) => 
                <MenuItem key={menu.id} onClick={()=> handleClose(menu)}>{menu.title}</MenuItem>
              ) }
          </Menu>
        </Grid>
        <Grid xs item>
          <Card elevation={0} sx={{
            mt: 2
          }}>
            <PerfectScrollbar>
              <Box sx={{ minWidth: activeTable ? 1800 : 1000 }}>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table stickyHeader aria-label="Employee list" id="employee-list">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            sx={{
                              '& .MuiSvgIcon-root': {
                                fontSize: 18
                              }
                            }}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>
                          Employee ID
                        </TableCell>
                        <TableCell>
                          Email
                        </TableCell>
                        {
                          activeTable == 1 &&
                          <TableCell>
                            Gender
                          </TableCell>
                        }
                        <TableCell>
                          Phone Number
                        </TableCell>
                        {
                           activeTable == 0 && <TableCell>
                           Subscription Activated
                         </TableCell>
                        }
                        
                        {
                          activeTable == 1 && 
                          <>
                            <TableCell>
                              Consultation For
                            </TableCell>
                            <TableCell>
                              Consultation Started At
                            </TableCell>
                          </>
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {((displayEmployees.length > 0) ? displayEmployees : displayEmployees.slice(page * limit, (page + 1) * limit)).map((employee, idx) => (
                        <TableRow
                          hover
                          key={idx}
                        // key={employee.requestId}
                        // selected={selectedEmployeeIds.indexOf(employee.requestId) !== -1}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              sx={{
                                '& .MuiSvgIcon-root': {
                                  fontSize: 18
                                }
                              }}
                              value="true"
                            />
                          </TableCell>
                          <TableCell>
                            {employee.employeeId}
                          </TableCell>
                          <TableCell>
                            {employee.email ? employee.email.toLowerCase() : ''}
                          </TableCell>
                          {
                            activeTable == 1 &&
                            <TableCell>
                              {employee.gender}
                            </TableCell>
                          }
                          <TableCell>
                            {employee.phoneNumber}
                          </TableCell>
                         {
                         activeTable == 0 && <TableCell>
                            {moment(employee.SubscriptionActivatedOnDateTime).format('DD/MM/YYYY')}
                          </TableCell>
                         } 
                          {
                            activeTable == 1 && 
                            <>
                              <TableCell>
                                {employee.consultationTakenFor}
                              </TableCell>
                              <TableCell>
                                {moment(employee.consultationStartDateTime).format('DD/MM/YYYY HH:mm')}
                              </TableCell>
                            </>
                          }
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </PerfectScrollbar>
            <TablePagination
              component="div"
              count={totalCount}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Card>
        </Grid>

      </Grid>
    </>
  )
}

export default GoldResults
